/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { isError } from "@epic-mw/error-types";

import { getApiPath } from "../utils";

interface GetOptInRes {
	settingValue?: boolean;
	error?: string;
}
export const getOptIn = async (): Promise<GetOptInRes> => {
	try {
		const response = await fetch(
			`${getApiPath()}/communication/opt-in?setting=${process.env.NEXT_PUBLIC_COMMUNICATIONS_SETTING}`,
			{
				credentials: "include",
			},
		);
		const json: GetOptInRes = await response.json();
		return json;
	} catch (err) {
		console.error("getOptIn() failed to load", isError(err) && err.message);
		throw err;
	}
};

interface UpdateOptInRes {
	success?: boolean;
	error?: string;
}
export const updateOptIn = async (): Promise<UpdateOptInRes> => {
	try {
		const response = await fetch(`${getApiPath()}/communication/opt-in`, {
			method: "POST",
			body: JSON.stringify({ setting: process.env.NEXT_PUBLIC_COMMUNICATIONS_SETTING }),
			credentials: "include",
		});
		const json: UpdateOptInRes = await response.json();
		return json;
	} catch (err) {
		console.error("postOptIn() failed to load", isError(err) && err.message);
		throw err;
	}
};
